// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"81f5ade3","453":"d6855f65"}[chunkId] + ".chunk.js";
};